import { i18n } from '@fs/zion-locale'

export default {
  defaultHeading: i18n.t('NoResultsView.defaultHeading', 'No Results'),
  defaultMessage: i18n.t('NoResultsView.defaultMessage', 'No items match your search.'),
}
